module.exports = __webpack_public_path__ + "media/ambiente.c27ef8fa.wav";